import { Box, Button, Stack, Typography } from "@mui/material";
import palette_custom from "../../palette";
import { LockOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const baseUrl = process.env.REACT_APP_BASE_URL_WATER;
console.log("baseUrl:", baseUrl);

const WaterActivationBox = () => {
  const { t } = useTranslation();

  const userData = useSelector((state) => state.user?.data);
  const handleActivationClick = () => {
    if (userData) {
      const params = new URLSearchParams({
        name: userData?.name,
        surname: userData?.surname,
        email: userData?.email,
      });
      window.location.href = `${baseUrl}/activation_request?${params.toString()}`;
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      flexDirection="column"
      gap={3}
    >
      <Box
        display="flex"
        bgcolor={`${palette_custom.primary}66`}
        borderRadius="30px"
        width="60px"
        height="60px"
        alignItems="center"
        justifyContent="center"
      >
        <LockOutlined color="primary" sx={{ fontSize: 35 }} />
      </Box>
      <Stack direction="column" spacing={1} width="100%" alignItems="center">
        <Typography fontSize="16px" fontWeight="bold">
          {t("home.water_activation_box.title")}
        </Typography>
        <Typography fontSize="14px">
          {t("home.water_activation_box.subtitle")}
        </Typography>
      </Stack>
      <Button
        variant="contained"
        sx={{ textTransform: "none" }}
        onClick={handleActivationClick}
      >
        {t("home.water_activation_box.button")}
      </Button>
    </Box>
  );
};

export default WaterActivationBox;
